import { createContext, useState, type ReactNode } from "react"

import type { PUser } from "../types/Types"


interface AuthContext { user: PUser | undefined, setUser: any }

export const AuthContext = createContext<AuthContext>({ user: undefined, setUser:() => {} })


interface AuthProviderProps { children: ReactNode}

export const AuthProvider = (props:AuthProviderProps) => {

    const [user, setUser] = useState< PUser | undefined >(undefined)
    
    return (
        <AuthContext.Provider value={{user: user, setUser:setUser}}>
            {props.children}
        </AuthContext.Provider>
    )
}